import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import {
  ShieldCheck, BadgeCheck, Award, Users, GraduationCap,
  Clock, Building2, Stethoscope, Sparkles,
  Package as PackageIcon, Plane, FileText, Train, Droplet, Hotel,
  Utensils, Bus, BookOpen, HeartPulse, MapPin, Phone,
} from "lucide-react";

const CS_WA = "https://wa.me/6282114294101?text=Assalamualaikum%2C%20saya%20tertarik%20dengan%20paket%20Haji%20Khusus%20Platinum%20*5%20Batik%20Travel";

const HERO_BG = `${(process.env.REACT_APP_BACKEND_URL || "")}/api/static/hero/haji.jpg`;
const HOTEL_MAKKAH = "https://cdn.ptbatik.co.id/wp-content/uploads/2026/03/hotel-makkah-1024x682.jpeg";
const HOTEL_MADINAH = "https://cdn.ptbatik.co.id/wp-content/uploads/2026/03/hotel-madinah-1024x682.jpeg";
const MAKTAB_ARMUZNA = "https://cdn.ptbatik.co.id/wp-content/uploads/2026/03/maktab-armuzna-1024x683.jpeg";

const USTADZ = [
  { slug: "erlan-iskandar", name: "Ustadz Erlan Iskandar", ext: "png" },
  { slug: "abu-yazid-nurdin", name: "Ustadz Abu Yazid Nurdin", ext: "png" },
  { slug: "ristiyan-ragil", name: "Ustadz Ristiyan Ragil", ext: "png" },
];

const GALLERY = [
  { src: "https://cdn.ptbatik.co.id/wp-content/uploads/2026/07/lempar-jumrah-11-12-dzulhijah-1024x576.jpg", alt: "Lempar Jumrah 11-12 Dzulhijah" },
  { src: "https://cdn.ptbatik.co.id/wp-content/uploads/2026/03/Jamaah-haji-khusus-batik-travel-1024x577.jpeg", alt: "Jamaah Haji Khusus" },
  { src: "https://cdn.ptbatik.co.id/wp-content/uploads/2026/07/perjalanan-ke-mina-1024x576.jpg", alt: "Perjalanan ke Mina" },
  { src: "https://cdn.ptbatik.co.id/wp-content/uploads/2026/03/Jamaah-Haji-Khusus-Batik-Travel-3-1024x576.jpeg", alt: "Jamaah Haji Khusus" },
  { src: "https://cdn.ptbatik.co.id/wp-content/uploads/2026/03/jamaah-haji-khusus-2025-1024x576.jpeg", alt: "Jamaah Haji Khusus 2025" },
  { src: "https://cdn.ptbatik.co.id/wp-content/uploads/2026/07/tahalul-1024x576.jpg", alt: "Tahalul" },
  { src: "https://cdn.ptbatik.co.id/wp-content/uploads/2026/07/Wukuf-di-Arafah-1024x576.jpg", alt: "Wukuf di Arafah" },
  { src: "https://cdn.ptbatik.co.id/wp-content/uploads/2026/07/lempar-jumrah-1024x576.jpg", alt: "Lempar Jumroh" },
  { src: "https://cdn.ptbatik.co.id/wp-content/uploads/2026/03/Jamaah-Haji-Khusus-Batik-Travel-2-1-1024x577.jpeg", alt: "Jamaah Haji Khusus" },
];

const WHY = [
  { i: ShieldCheck, t: "Berizin Resmi", d: "Memiliki izin resmi sebagai Penyelenggara Ibadah Haji Khusus (PIHK) sesuai regulasi pemerintah." },
  { i: BadgeCheck, t: "Diawasi Kemenhaj", d: "Program diselenggarakan sesuai ketentuan dan pengawasan Kementerian Haji dan Umrah RI." },
  { i: Award, t: "Sertifikat BNSP", d: "Tim pembimbing dan tenaga profesional telah tersertifikasi oleh Badan Nasional Sertifikasi Profesi." },
  { i: Users, t: "Berpengalaman", d: "Didampingi tim berpengalaman dalam membimbing jamaah selama ibadah haji." },
  { i: GraduationCap, t: "Dibimbing Ustadz", d: "Haji didampingi oleh ustadz dan muthawif berpengalaman." },
];

const KEUNGGULAN = [
  { i: Clock, t: "Masa Tunggu Singkat", d: "Kesempatan berangkat lebih cepat melalui kuota resmi haji khusus." },
  { i: Building2, t: "Hotel Bintang 5", d: "Akomodasi premium berlokasi strategis dekat Masjidil Haram dan Masjid Nabawi." },
  { i: GraduationCap, t: "Pembimbing Profesional", d: "Didampingi ustadz pembimbing profesional yang telah tersertifikasi." },
  { i: Stethoscope, t: "Tim Dokter", d: "Pendampingan medis untuk menjaga kondisi kesehatan jamaah selama ibadah." },
  { i: Sparkles, t: "Fasilitas Eksklusif", d: "Layanan yang dirancang lebih personal dan nyaman untuk kelancaran jamaah." },
];

const FASILITAS = [
  { i: PackageIcon, t: "Perlengkapan Haji Eksklusif" },
  { i: Plane, t: "Tiket Economy Class Jakarta PP" },
  { i: FileText, t: "Visa Haji & Apartemen Transit" },
  { i: Train, t: "Kereta Cepat Haramain" },
  { i: Droplet, t: "Air ZamZam 5 Liter" },
  { i: Hotel, t: "Hotel Makkah ★5 Pelataran" },
  { i: Hotel, t: "Hotel Madinah ★5 Pelataran" },
  { i: Utensils, t: "Makan 3× / hari" },
  { i: Bus, t: "Transportasi Bus AC" },
  { i: BookOpen, t: "Pembimbing Ibadah & Muthawif" },
  { i: HeartPulse, t: "Tim Dokter Batik Travel" },
  { i: GraduationCap, t: "Bimbingan Manasik Haji" },
];

const BELUM_TERMASUK = [
  "Biaya Pembuatan Paspor dan Vaksinasi",
  "Biaya Medical Check-Up",
  "Pengeluaran Pribadi, Kelebihan Bagasi, Laundry",
  "Jasa Pelayanan Dorong Kursi Roda",
  "Akomodasi Daerah ke Jakarta PP",
  "Administrasi PIHK Asal Bagi yang Pindah PIN",
  "Dam Tamattu'",
];

const NOTES = [
  "Menerima Pindah PIN PIHK",
  "Program & Harga Bisa Berubah",
  "Bagi Jamaah Baru, Estimasi Masa Tunggu 10 tahun",
  "Segala Administrasi Melalui PT Baitullah Tiga Kharisma",
];

const BADGES = [
  { t: "Berizin Resmi", d: "PPIU & PIHK" },
  { t: "Berangkat dari", d: "Jakarta (CGK)" },
  { t: "Jadwal & Tiket", d: "Confirmed" },
  { t: "Ibadah Sesuai", d: "Tuntunan" },
];

const API = process.env.REACT_APP_BACKEND_URL;

export default function HajiKhusus() {
  return (
    <div data-testid="haji-khusus-page" className="bg-background">
      <SEO
        title="Haji Khusus Platinum ★5 — BATIK Tour & Travel"
        titleEn="Special Hajj Platinum ★5 — BATIK Tour & Travel"
        description="Program Haji Khusus Platinum ★5 BATIK Tour & Travel — hotel bintang 5 pelataran, pembimbing bersertifikasi, tim dokter, Kereta Cepat Haramain. DP mulai USD 4.500. Konsultasi sekarang."
        descriptionEn="Special Hajj Platinum ★5 with BATIK Tour & Travel — 5-star hotels near Masjidil Haram & Nabawi, certified guides, medical team, Haramain High-Speed Rail. DP from USD 4,500."
      />

      {/* HERO */}
      <section className="relative pt-32 pb-24 lg:pt-40 lg:pb-32 overflow-hidden isolate">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${HERO_BG})` }}
          aria-hidden
        />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/95 via-primary/85 to-primary/70" aria-hidden />
        {/* Bottom smooth fade into next section */}
        <div className="pointer-events-none absolute bottom-0 inset-x-0 h-32 bg-gradient-to-b from-transparent to-background" aria-hidden />
        <div className="container-x relative">
          <div className="max-w-3xl">
            <p className="text-accent font-medium text-xs tracking-[0.25em] uppercase mb-4" data-testid="haji-overline">
              BATIK TOUR &amp; TRAVEL — PROGRAM EKSKLUSIF
            </p>
            <h1 className="font-serif text-white text-5xl lg:text-6xl xl:text-7xl leading-[1.05] tracking-tight" data-testid="haji-hero-title">
              Haji Khusus <span className="text-accent italic">Platinum ★5</span>
            </h1>
            <p className="mt-6 text-lg lg:text-xl text-white/90 max-w-2xl leading-relaxed">
              Wujudkan perjalanan ibadah haji Anda dengan pelayanan premium, hotel bintang 5 pelataran dekat masjid, dan pendampingan ibadah langsung dibimbing ustadz bersertifikasi resmi.
            </p>
            <div className="mt-9 flex flex-wrap gap-3">
              <a
                href={CS_WA}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="haji-cta-wa-hero"
                className="inline-flex items-center gap-2 bg-accent text-primary font-semibold px-7 py-3.5 rounded-full hover:bg-accent/90 transition-colors shadow-lg"
              >
                <Phone className="h-4 w-4" /> Konsultasi via WhatsApp
              </a>
              <div className="inline-flex items-center gap-2 border border-white/40 text-white px-6 py-3.5 rounded-full bg-white/10 backdrop-blur">
                <span className="text-xs uppercase tracking-widest opacity-80">DP mulai</span>
                <span className="font-serif text-lg font-semibold text-accent">USD 4.500</span>
              </div>
            </div>

            {/* Badges */}
            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl">
              {BADGES.map((b, idx) => (
                <div
                  key={idx}
                  data-testid={`haji-badge-${idx}`}
                  className="border border-white/20 bg-white/5 backdrop-blur-sm rounded-lg p-4"
                >
                  <p className="text-[10px] uppercase tracking-widest text-white/60">{b.t}</p>
                  <p className="mt-1 font-serif text-lg text-accent leading-tight">{b.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* WHY BATIK */}
      <section className="py-20 lg:py-28">
        <div className="container-x">
          <div className="max-w-2xl">
            <p className="overline mb-4">Mengapa Batik Travel</p>
            <h2 className="font-serif text-4xl lg:text-5xl text-primary tracking-tight">Kenapa Harus Batik Travel</h2>
            <p className="mt-5 text-muted-foreground leading-relaxed">
              Karena haji bukan sekadar perjalanan, tapi panggilan hati. Batik Travel mendampingi setiap langkah Anda dengan amanah, pelayanan terbaik, dan bimbingan yang tulus agar ibadah terasa lebih tenang, khusyuk, dan bermakna.
            </p>
          </div>
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-5 gap-6">
            {WHY.map((w, idx) => {
              const Icon = w.i;
              return (
                <div
                  key={idx}
                  data-testid={`haji-why-${idx}`}
                  className="border border-border rounded-lg p-6 hover:border-accent hover:shadow-md transition-all bg-card"
                >
                  <div className="w-11 h-11 rounded-full bg-accent/15 text-accent grid place-items-center">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="mt-4 font-serif text-lg text-primary">{w.t}</h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{w.d}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* KEUNGGULAN */}
      <section className="py-20 lg:py-28 bg-muted/40 border-y border-border">
        <div className="container-x">
          <div className="max-w-2xl">
            <p className="overline mb-4">Mengapa Pilih Platinum ★5?</p>
            <h2 className="font-serif text-4xl lg:text-5xl text-primary tracking-tight">Keunggulan Haji Khusus Platinum</h2>
            <p className="mt-5 text-muted-foreground leading-relaxed">
              Program haji eksklusif dengan layanan prioritas, akomodasi premium, dan pendampingan profesional untuk memastikan ibadah Anda lebih nyaman, tenang, dan terarah.
            </p>
          </div>
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-5 gap-6">
            {KEUNGGULAN.map((k, idx) => {
              const Icon = k.i;
              return (
                <div
                  key={idx}
                  data-testid={`haji-keunggulan-${idx}`}
                  className="bg-white border border-border rounded-lg p-6 hover:border-accent transition-all"
                >
                  <Icon className="h-8 w-8 text-accent" />
                  <h3 className="mt-4 font-serif text-lg text-primary">{k.t}</h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{k.d}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* FASILITAS */}
      <section className="py-20 lg:py-28">
        <div className="container-x grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <p className="overline mb-4">Fasilitas Program</p>
            <h2 className="font-serif text-4xl lg:text-5xl text-primary tracking-tight">Fasilitas Haji Khusus Platinum</h2>
            <p className="mt-5 text-muted-foreground leading-relaxed">
              Beragam fasilitas premium disiapkan lengkap untuk memastikan perjalanan ibadah haji Anda berjalan nyaman, aman, dan terorganisir dengan baik sejak keberangkatan hingga kembali ke tanah air.
            </p>
            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
              {FASILITAS.map((f, idx) => {
                const Icon = f.i;
                return (
                  <li key={idx} className="flex items-start gap-3" data-testid={`haji-fasilitas-${idx}`}>
                    <div className="mt-0.5 shrink-0 w-8 h-8 rounded-full bg-accent/15 text-accent grid place-items-center">
                      <Icon className="h-4 w-4" />
                    </div>
                    <span className="text-primary text-sm leading-relaxed">{f.t}</span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="aspect-[4/3] rounded-lg overflow-hidden border border-border shadow-xl">
              <img src={HERO_BG} alt="Kereta Cepat Haramain" className="w-full h-full object-cover" />
            </div>
            <p className="mt-3 text-xs text-muted-foreground italic text-center">Kereta Cepat Haramain — Makkah ⇄ Madinah</p>
          </div>
        </div>
      </section>

      {/* HOTEL & AKOMODASI */}
      <section className="py-20 lg:py-28 bg-primary text-white">
        <div className="container-x">
          <div className="max-w-2xl">
            <p className="text-accent font-medium text-xs tracking-[0.25em] uppercase mb-4">Hotel &amp; Akomodasi</p>
            <h2 className="font-serif text-4xl lg:text-5xl text-white tracking-tight">Hotel &amp; Akomodasi Haji Khusus</h2>
            <p className="mt-5 text-white/80 leading-relaxed">
              Akomodasi strategis yang dipilih untuk mendukung kenyamanan dan kekhusyukan ibadah di Tanah Suci.
            </p>
          </div>
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {[
              { img: HOTEL_MAKKAH, badge: "Hotel Makkah ★5", name: "Swissotel / Movenpick / Setaraf", dist: "± 50–150 meter ke pelataran Masjidil Haram" },
              { img: HOTEL_MADINAH, badge: "Hotel Madinah ★5", name: "Maysan Al Harithia / Setaraf", dist: "± 75 meter ke pelataran Masjid Nabawi" },
              { img: MAKTAB_ARMUZNA, badge: "Maktab Armuzna", name: "Maktab VIP 111–116", dist: "Fasilitas maktab premium untuk Wukuf & Mabit" },
            ].map((h, idx) => (
              <div
                key={idx}
                data-testid={`haji-hotel-${idx}`}
                className="bg-white/5 border border-white/10 rounded-lg overflow-hidden backdrop-blur-sm"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={h.img} alt={h.badge} className="w-full h-full object-cover" />
                </div>
                <div className="p-5">
                  <p className="text-xs uppercase tracking-widest text-accent">{h.badge}</p>
                  <h3 className="mt-2 font-serif text-xl text-white">{h.name}</h3>
                  <p className="mt-2 text-sm text-white/70 flex items-start gap-1.5">
                    <MapPin className="h-3.5 w-3.5 mt-0.5 shrink-0 text-accent" />
                    {h.dist}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 flex flex-col md:flex-row items-center gap-6 justify-between bg-black/30 border border-accent/30 rounded-lg p-8">
            <div>
              <p className="text-accent text-xs uppercase tracking-widest">Daftar Sekarang</p>
              <p className="mt-1 font-serif text-2xl text-white">Amankan porsi Haji Khusus Anda sekarang</p>
            </div>
            <a
              href={CS_WA}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="haji-cta-wa-hotel"
              className="inline-flex items-center gap-2 bg-accent text-primary font-semibold px-7 py-3.5 rounded-full hover:bg-accent/90 transition-colors shadow-lg whitespace-nowrap"
            >
              <Phone className="h-4 w-4" /> Konsultasi WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* PEMBIMBING */}
      <section className="py-20 lg:py-28">
        <div className="container-x">
          <div className="max-w-2xl">
            <p className="overline mb-4">Tim Pembimbing</p>
            <h2 className="font-serif text-4xl lg:text-5xl text-primary tracking-tight">Pembimbing Haji Khusus Berpengalaman</h2>
            <p className="mt-5 text-muted-foreground leading-relaxed">
              Didampingi ustadz pembimbing Batik Travel yang berpengalaman dalam membimbing manasik dan ibadah haji sesuai tuntunan.
            </p>
          </div>
          <div className="mt-12 grid md:grid-cols-3 gap-8">
            {USTADZ.map((u, idx) => (
              <div key={u.slug} data-testid={`haji-ustadz-${idx}`} className="text-center">
                <div className="aspect-square rounded-lg overflow-hidden ring-1 ring-border bg-gradient-to-br from-slate-100 to-slate-50 hover:ring-2 hover:ring-accent transition-all">
                  <img
                    src={`${API}/api/static/ustadz/${u.slug}.${u.ext}`}
                    alt={u.name}
                    className="w-full h-full object-cover object-center"
                    loading="lazy"
                  />
                </div>
                <h3 className="mt-4 font-serif text-lg text-primary">{u.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* GALERI */}
      <section className="py-20 lg:py-28 bg-muted/40 border-y border-border">
        <div className="container-x">
          <div className="max-w-2xl">
            <p className="overline mb-4">Galeri Jamaah Haji Khusus</p>
            <h2 className="font-serif text-4xl lg:text-5xl text-primary tracking-tight">Galeri Perjalanan Haji Jamaah Batik Travel</h2>
            <p className="mt-5 text-muted-foreground leading-relaxed">
              Dokumentasi perjalanan jamaah Batik Travel selama menjalankan ibadah haji di Tanah Suci.
            </p>
          </div>
          <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
            {GALLERY.map((g, idx) => (
              <a
                key={idx}
                href={g.src}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`haji-gallery-${idx}`}
                className="group aspect-video rounded-md overflow-hidden border border-border block"
              >
                <img
                  src={g.src}
                  alt={g.alt}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* INFORMASI TAMBAHAN */}
      <section className="py-20 lg:py-28">
        <div className="container-x">
          <div className="max-w-2xl">
            <p className="overline mb-4">Informasi Tambahan</p>
            <h2 className="font-serif text-4xl lg:text-5xl text-primary tracking-tight">Informasi Program &amp; Ketentuan</h2>
            <p className="mt-5 text-muted-foreground leading-relaxed">
              Untuk memberikan gambaran yang lebih jelas kepada calon jamaah, berikut beberapa informasi terkait komponen biaya dan ketentuan program Haji Khusus Platinum.
            </p>
          </div>
          <div className="mt-10 grid md:grid-cols-2 gap-6">
            <div className="border border-border rounded-lg p-6 bg-card" data-testid="haji-belum-termasuk">
              <h3 className="font-serif text-xl text-primary uppercase tracking-wide">Belum Termasuk</h3>
              <ul className="mt-4 space-y-2">
                {BELUM_TERMASUK.map((b, idx) => (
                  <li key={idx} className="text-sm text-muted-foreground flex items-start gap-2">
                    <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-accent shrink-0" />
                    {b}
                  </li>
                ))}
              </ul>
            </div>
            <div className="border border-border rounded-lg p-6 bg-card" data-testid="haji-note">
              <h3 className="font-serif text-xl text-primary uppercase tracking-wide">Note</h3>
              <ul className="mt-4 space-y-2">
                {NOTES.map((n, idx) => (
                  <li key={idx} className="text-sm text-muted-foreground flex items-start gap-2">
                    <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-accent shrink-0" />
                    {n}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 lg:py-24 bg-primary">
        <div className="container-x text-center max-w-3xl mx-auto">
          <p className="text-accent text-xs uppercase tracking-[0.3em] mb-4">DP MULAI USD 4.500</p>
          <h2 className="font-serif text-4xl lg:text-5xl text-white tracking-tight">
            Wujudkan Panggilan Baitullah Anda
          </h2>
          <p className="mt-6 text-white/80 leading-relaxed">
            Konsultasikan rencana Haji Khusus Anda bersama tim customer service Batik Travel — kami bantu proses pendaftaran, dokumen, hingga keberangkatan.
          </p>
          <div className="mt-9 flex flex-wrap gap-4 justify-center">
            <a
              href={CS_WA}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="haji-cta-wa-final"
              className="inline-flex items-center gap-2 bg-accent text-primary font-semibold px-8 py-4 rounded-full hover:bg-accent/90 transition-colors shadow-lg"
            >
              <Phone className="h-4 w-4" /> Konsultasi WhatsApp
            </a>
            <Link
              to="/packages?tab=haji"
              data-testid="haji-cta-packages"
              className="inline-flex items-center gap-2 border border-white/40 text-white font-semibold px-8 py-4 rounded-full hover:bg-white/10 transition-colors"
            >
              Lihat Paket Haji
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
